import React from 'react';
import AdminContentPostsPage from './AdminContentPostsPage';

const AdminNewsPage = () => <AdminContentPostsPage type="News" title="Новости" />;

export default AdminNewsPage;
